import {
  PointLayerTypes,
  PopupTypes,
  ReportStatus,
} from '../span-progress-entities';

export const landAgreementStyles = {
  default: {
    weight: 1,
    opacity: 0.2,
    fillOpacity: 0.2,
  },
  selected: {
    weight: 3,
    opacity: 0.75,
    fillOpacity: 0.6,
  },
};

export const landAgreementColors = {
  DONE: '#008000',
  NOT_COMPLETED: '#ff0028',
  NOT_NEEDED: '#000',
};

export interface PointStyles {
  fillColor: string;
  weight: number;
  radius: number;
}

export const pointInfo: {
  [key in PointLayerTypes]: {
    pointStyle: PointStyles;
    popup?: PopupTypes;
  };
} = {
  HC: {
    pointStyle: { fillColor: '#7FC9FF', weight: 1, radius: 7 },
    popup: PopupTypes.Households,
  },
  HP: {
    pointStyle: { fillColor: '#FFB27F', weight: 1, radius: 7 },
    popup: PopupTypes.Households,
  },
  WELL: {
    pointStyle: { fillColor: '#6f4646', weight: 1, radius: 7 },
    popup: PopupTypes.DistPoint,
  },
  MANHOLE: {
    pointStyle: { fillColor: '#6f4646', weight: 1, radius: 7 },
    popup: PopupTypes.DistPoint,
  },
  CABINET: {
    pointStyle: { fillColor: '#e8e950', weight: 1, radius: 7 },
    popup: PopupTypes.DistPoint,
  },
  JOINTPOINT: {
    pointStyle: { fillColor: '#34f724', weight: 1, radius: 7 },
  },
  INFO: {
    pointStyle: { fillColor: '#9a9a9a', weight: 2, radius: 9 },
    popup: PopupTypes.Info,
  },
  TRV: {
    pointStyle: { fillColor: '#e8e8e8', weight: 2, radius: 9 },
    popup: PopupTypes.Info,
  },
  SDP: {
    pointStyle: { fillColor: '#fab1e2', weight: 1, radius: 7 },
    popup: PopupTypes.Ductpoint,
  },
  MULTIHP: {
    pointStyle: { fillColor: '#7FC9FF', weight: 1, radius: 7 },
    popup: PopupTypes.MultiHP,
  },
  MULTIHC: {
    pointStyle: { fillColor: '#7FC9FF', weight: 1, radius: 7 },
    popup: PopupTypes.MultiHC,
  },
  MULTIHOUSEHOLD: {
    pointStyle: { fillColor: '#7FC9FF', weight: 1, radius: 7 },
    popup: PopupTypes.MultiHouseHold,
  },
  MULTIWELL: {
    pointStyle: { fillColor: '#6f4646', weight: 1, radius: 7 },
    popup: PopupTypes.MultiWell,
  },
  HUB: {
    pointStyle: { fillColor: '#b7dff0', weight: 1, radius: 7 },
    popup: PopupTypes.Hub,
  },
  SITE: {
    pointStyle: { fillColor: '#fe7f7f', weight: 1, radius: 7 },
    popup: PopupTypes.Site,
  },
  KP: {
    pointStyle: { fillColor: '#fab1e2', weight: 1, radius: 7 },
    popup: PopupTypes.Ductpoint,
  },
};

export const reportStatusColors: { [key in ReportStatus]: string } = {
  DONE: '#00FF38',
  DONE_WITH_DEVIATION: '#1a69d6',
  PLACEMENT_OF_HUB_DONE: '#00FF38',
  IN_PROGRESS: '#ba1ad6',
  UNKNOWN: '#000000',
  DONE_WITHOUT_IMAGES: '#FFD42A',
};

export const defaultReportStatus: { status: ReportStatus; offline: boolean } = {
  status: ReportStatus.Unknown,
  offline: false,
};

export const spanStatusColors: { [key in ReportStatus]: string } = {
  DONE: '#00FF38',
  DONE_WITH_DEVIATION: '#1a69d6',
  PLACEMENT_OF_HUB_DONE: '#00FF38',
  IN_PROGRESS: '#ba1ad6',
  UNKNOWN: '#000000',
  DONE_WITHOUT_IMAGES: '#FFD42A',
};
